module.exports = {
  title: 'Blur Theme Switch with Reanimated & Skia 🎨',
  author: 'Enzo Manuel Mangano',
  date: '2024-07-09',
  slug: 'interaction-appearance',
  tags: ['reanimated', 'skia'],
};
